module.exports = __webpack_public_path__ + "static/media/FAQ.c5db27d8.jpg";